export default "__VITE_ASSET___qX65$XF__"